const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "조치 완료일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      { component: "search-disaster-types", label: "재해형태", value: "disaster", query: { dty: "disaster" }, options: {} },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "작성일", "재해형태", "조치 완료일", "요청일시"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "body.subInfo2.조치완료일", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "body.subInfo2.조치완료일", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({ key: "body.subInfo.재해형태", operator: "LIKE", value: `%${search.disaster}%` });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "요청자 구분",
        key: "body.요청자구분",
      },
      {
        name: "요청일시",
        key: "body.subInfo.요청일시",
      },
      {
        name: "재해형태",
        key: "body.subInfo.재해형태",
      },
      {
        name: "조치 현황",
        key: "body.subInfo2.조치현황",
      },
      {
        name: "조치 완료일",
        key: "body.subInfo2.조치완료일",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return func.getContent(value).요청자구분; // 요청자구분
        case 2: { // 요청일 -> 요청일시
          const 요청일시 = func.getContent(value).subInfo.요청일시;

          if (요청일시 && 요청일시.date && 요청일시.time && 요청일시.date !== "" && 요청일시.time !== "") {
            return `${요청일시.date} ${요청일시.time}`;
          } else if (요청일시 && 요청일시.date && 요청일시.date !== "") {
            return 요청일시.date; // 요청일시가 날짜만 있을 경우
          }

          // 요청일시가 없을 경우 요청일을 사용
          return func.getContent(value).subInfo.요청일;
        }

        case 3:
          return func.getContent(value).subInfo.재해형태; // 재해형태
        case 4:
          return func.getContent(value).subInfo2.조치현황; // 자격번호
        case 5:
          return func.getContent(value).subInfo2.조치완료일; // 조치완료일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
